import React from "react";
import * as Datetime from "react-datetime";
import { FormField } from "./";
import { ValidatedFormFieldBase } from "../validation";
import * as moment from "moment";

interface OwnProps {
    className?: string;
    format?: string;
    inputClassName?: string;
    viewDate?: Date | string | moment.Moment;
    viewMode?: Datetime.ViewMode | number;
}

interface OwnState {
    open: boolean;
}

export class DatePickerField extends ValidatedFormFieldBase<OwnProps, OwnState> {

    constructor(props: any) {
        super(props);
        this.state = {
            open: false,
        };
    }

    public render() {
        const format = this.props.format || "MM/DD/YYYY";
        const label = this.getLabel(this.props.label);
        const value: Date | null | undefined = this.getValue() as Date;

        return <FormField {...this.props} errors={this.getErrors()} label={label} name={this.props.name} required={this.isRequired(this.props.required)}>
            <Datetime
                className={this.props.className}
                closeOnSelect
                dateFormat={format}
                onChange={(date) => this.handleChange(date)}
                inputProps={{
                    className: this.props.inputClassName || "txt-date",
                    value: value ? moment(value).format(format) : "",
                }}
                timeFormat={false}
                value={value ? moment(value) : undefined}
                viewDate={this.props.viewDate}
                viewMode={this.props.viewMode}
            />
        </FormField>;
    }

    private handleChange(date: string | moment.Moment) {
        const m = typeof date === "string"
            ? moment(date)
            : date;
        this.props.formComponent.setFieldValue(this.props.name, m.isValid() ? m.toDate() : null);
        // this.setState({ ...this.state, open: false });
    }
}



// WEBPACK FOOTER //
// ./src/components/editors/DatePickerField.tsx